module.exports = __webpack_public_path__ + "img/ic_circle_red.24e5d817.svg";